module.exports = __webpack_public_path__ + "media/images/venice/down-arrow-84b9ae7bc268d5c3ff5f02817e31dcb0.svg";